/** @format */

import { notificationConstants } from '../notifications/notifications';
import { defaultActions } from '../../core/actionsDefault';
import { apiCall } from '../../core/apiCall';

export const tariffConstants = {
    LIST: 'tariffs_list',
    ITEM: 'tariffs_item',
    EDIT: 'tariffs_edit',
    DELETE: 'tariffs_delete',
    MANAGE: 'tariffs_manage',
    ADD: 'tariffs_add',
    SELECT: 'tariffs_select_item',
};

export class tariffsActions extends defaultActions {
    static getTariffsList = (url, filter, orders, actionType, callback, options) =>
        defaultActions.getCollection(url, filter, orders, actionType, callback, options);

    static get = (url) => {
        return (dispatch) => {
            apiCall
                .get(url)
                .then((item) => {
                    dispatch(success(item));
                })
                .catch((error) => {
                    if (error.status === 404) {
                        dispatch(itemNotFound(error));
                    } else {
                        dispatch(failure(error));
                    }
                });
        };

        function success(item) {
            return { type: tariffConstants.ITEM, item: item };
        }

        function itemNotFound(error) {
            return { type: notificationConstants.NOTFOUND, error: error };
        }

        function failure(error) {
            return { type: notificationConstants.ERROR };
        }
    };
}
